export default __webpack_public_path__ + "static/PNS_PHOTOGRAPHY_4-78fbee5a40979795984b805bbbe9fa54.jpg";